@if (firebaseUser.isLoggedIn()) {
  <nav class="side-menu">
    @if (kiosk.locked()) {
      <button type="button" class="sidenav-button pointer" (click)="unlock(); blurNav($event)">
        <mat-icon aria-hidden="true">lock_open</mat-icon>
        <span>Desbloquear</span>
      </button>
    } @else {
      @if (membership.canManageClinicalRecords()) {
        <button type="button" class="sidenav-button pointer" appGuideAnchor="nav-patients" (click)="toPatientsPage(); blurNav($event)">
          <mat-icon aria-hidden="true">groups</mat-icon>
          <span>Pacientes</span>
        </button>
        <button type="button" class="sidenav-button pointer" (click)="toMedicinesPage(); blurNav($event)">
          <mat-icon aria-hidden="true">medication</mat-icon>
          <span>Medicamentos</span>
        </button>
        <button type="button" class="sidenav-button pointer" appGuideAnchor="nav-agenda" (click)="toCitasPage(); blurNav($event)">
          <mat-icon aria-hidden="true">calendar_month</mat-icon>
          <span>Agenda</span>
        </button>
        <button type="button" class="sidenav-button pointer" (click)="toPlantillasPage(); blurNav($event)">
          <mat-icon aria-hidden="true">description</mat-icon>
          <span>Plantillas</span>
        </button>
        @if (membership.canAccessAppointments()) {
          <button type="button" class="sidenav-button pointer" appGuideAnchor="nav-consultas" (click)="toAppointmentsPage(); blurNav($event)">
            <mat-icon aria-hidden="true">event_note</mat-icon>
            <span>Consultas</span>
          </button>
        }
        @if (teleconsultaEnabled()) {
          <button type="button" class="sidenav-button pointer" (click)="toTeleconsultaPage(); blurNav($event)">
            <mat-icon aria-hidden="true">videocam</mat-icon>
            <span>Teleconsulta</span>
          </button>
        }
      }
      @if (invoicingEnabled()) {
        <button type="button" class="sidenav-button pointer" (click)="toFacturacionPage(); blurNav($event)">
          <mat-icon aria-hidden="true">receipt_long</mat-icon>
          <span>Contabilidad</span>
        </button>
      }
      @if (membership.canManageSelectedBusiness()) {
        <button type="button" class="sidenav-button pointer" (click)="toConsultorioPage(); blurNav($event)">
          <mat-icon aria-hidden="true">local_hospital</mat-icon>
          <span>Consultorio</span>
        </button>
      }
      @if (membership.canManageClinicalRecords()) {
        <button type="button" class="sidenav-button pointer" (click)="toRegisterPage(); blurNav($event)">
          <mat-icon aria-hidden="true">tablet</mat-icon>
          <span>Registro</span>
        </button>
      }
      <button type="button" class="sidenav-button pointer" (click)="toPerfilPage(); blurNav($event)">
        <mat-icon aria-hidden="true">person</mat-icon>
        <span>Perfil</span>
        @if (membership.pendingInvites().length; as inviteCount) {
          <span class="invite-count">{{ inviteCount }}</span>
        }
      </button>
      @if (firebaseUser.isPlatformAdmin()) {
        <button type="button" class="sidenav-button pointer" (click)="toAdminPage(); blurNav($event)">
          <mat-icon aria-hidden="true">admin_panel_settings</mat-icon>
          <span>Admin</span>
        </button>
      }
    }
  </nav>
}
